module.exports = __webpack_public_path__ + "static/janko-6991aae84bb9af318679976ed15b561d.png";